export default {
    name: "",
    productionOrderBatchStepId: 0,
    productionOrderBatchId: 0,
    processFlowStepId: 0,
    operatorId: 0,
    groupsUser: "",
    responsibleName: "",
    groupsUserIds: "",
    responsibleIds: "",
    statusExecution: 0,
    statusStep: 0,
    note: "",
    operator: "",
    producedWeight: 0,
    department: "",
    productionOrderCodeLabel: "",
    groupProduct: "",
    unitFull: "",
    model: "",
    shotLastStart: "",
    statusProduction: "",
    enableCopyOtherStep:false,
    alternativeChosen:0,
    typeNonConformanceChosen:0,
}